import React from "react";
import GameInstructionModal from "./GameInstructionModal";

const ModalSmoothMovement = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Smooth Movement"
      gamePath="/userDashboard/game/smooth-movement"
      icon="solar:round-transfer-horizontal-bold"
      instructions={[
        "Patch your better eye.",
        "Track the moving letter on the screen and press the corresponding key on your keyboard."
      ]}
      isBinocular={false}
    />
  );
};

export default ModalSmoothMovement;
